import React from 'react'

import List from './list/List'

class MediaLibrary extends React.Component {
  render() {
    return(
      <div id="main">
        <h1>Mediathek</h1>
        <List
          {...this.props}
        />
      </div>
    )
  }
}

export default MediaLibrary
